import { CONTACT_EMAIL, useTitle } from './site.ts';

/** 소개 (CR-031): 설계 원칙(기획서 01-3)·멀티테넌트와 보안·문의. 회사명은 쓰지 않는다(2026-09-13 사용자 지시: 그냥 PRISM) */
const PRINCIPLES: Array<[string, string]> = [
  ['통제항목 허브', '안전성 확보조치 기준, ISMS-P 인증기준, ISO 27001/27701 등을 통제항목으로 등록하고 규정 조항·증적·점검 항목·수탁사·보호구역·AP 를 전부 통제항목에 연결합니다. "이 통제항목의 근거 규정과 증적이 무엇인가"를 한 화면에서 답할 수 있습니다.'],
  ['불변 버전', '규정 본문과 증적 파일은 덮어쓰지 않습니다. 새 버전은 새 행과 새 객체로 추가하고 이전 버전은 보존합니다. 증적 저장소는 사후 변조를 막는 잠금을 씁니다.'],
  ['모든 데이터의 이력', '버전 개념이 없는 대장류도 예외 없이 변경 이력을 남깁니다. DB 수준에서 모든 테이블의 입력·수정·삭제 전·후 값을 기록하므로 화면 코드가 누락해도 이력이 빠지지 않습니다.'],
  ['구조화된 문서', '규정은 자유 형식 문서가 아니라 조 → 항 → 호 트리로 저장합니다. 조항 단위 비교, 개정 이력표 자동 생성, 일관된 HTML 출력이 가능합니다.'],
];
const SECURITY: Array<[string, string]> = [
  ['테넌트 격리', '조직(테넌트)마다 데이터가 DB 행 수준에서 격리됩니다. 애플리케이션 계정은 격리 정책을 우회할 수 없습니다.'],
  ['접속기록', '주요 조회·다운로드·변경은 접속기록으로 남고, 기록은 체인으로 연결되어 사후 변조를 확인할 수 있습니다.'],
  ['계정 보안', '비밀번호 정책, 2단계 인증(MFA), 로그인 실패 잠금, 세션 만료를 조직별로 설정합니다.'],
  ['운영자 열람 통제', '플랫폼 운영자가 조직 데이터를 볼 때는 사유·기간을 기록한 읽기 전용 세션으로만 가능하며 조직 관리자에게 통지됩니다.'],
];

export function AboutPage() {
  useTitle('소개');
  return (
    <div>
      <section className="border-b border-slate-200 bg-slate-50">
        <div className="site-wrap py-12">
          <h1 className="text-[28px]! font-semibold! text-slate-900 tracking-tight">PRISM 소개</h1>
          <p className="mt-3 max-w-[720px] text-[14.5px] text-slate-600 leading-relaxed">PRISM 은 정보보호·개인정보보호 담당 조직이 규정, 증적, 자체점검, 위탁 대장, 결재를 한 시스템에서 관리하도록 만든 멀티테넌트 SaaS 입니다. 통제항목을 기준으로 업무를 연결하고, 승인된 버전은 바꾸지 않으며, 모든 변경을 이력으로 남기는 것을 원칙으로 설계했습니다.</p>
        </div>
      </section>

      <section className="site-wrap py-14">
        <h2 className="text-[22px]! font-semibold! text-slate-900">설계 원칙</h2>
        <ul className="mt-6 grid gap-px bg-slate-200 border border-slate-200 md:grid-cols-2">
          {PRINCIPLES.map(([t, d]) => <li key={t} className="bg-white p-5"><h3 className="text-[15px] font-semibold text-slate-900">{t}</h3><p className="mt-2 text-[13px] text-slate-600 leading-relaxed">{d}</p></li>)}
        </ul>
      </section>

      <section className="bg-slate-50 border-y border-slate-200">
        <div className="site-wrap py-14">
          <h2 className="text-[22px]! font-semibold! text-slate-900">멀티테넌트와 보안</h2>
          <ul className="mt-6 grid gap-px bg-slate-200 border border-slate-200 md:grid-cols-2">
            {SECURITY.map(([t, d]) => <li key={t} className="bg-white p-5"><h3 className="text-[15px] font-semibold text-slate-900">{t}</h3><p className="mt-2 text-[13px] text-slate-600 leading-relaxed">{d}</p></li>)}
          </ul>
        </div>
      </section>

      <section className="site-wrap py-14">
        <h2 className="text-[22px]! font-semibold! text-slate-900">문의</h2>
        <p className="mt-3 text-[13.5px] text-slate-600 leading-relaxed">도입·계약·기술 문의는 <a className="text-accent-strong hover:underline" href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a> 로 보내주세요.</p>
        <a href={`mailto:${CONTACT_EMAIL}`} className="mt-4 h-9 px-4 inline-flex items-center bg-accent text-white text-[13px] font-semibold hover:bg-accent-strong">도입 문의</a>
      </section>
    </div>
  );
}
